const calculateCurrentIndexes = () => {
    const startYear = 2023; // Fiscal year starts from July 2023
    const startMonth = 6; // July is the 0th month in our indexing
  
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // JavaScript months are 0-based (Jan = 0, ..., Dec = 11)
  
    // Calculate the current month index relative to July 2023
    const currentMonthIndex = (currentYear - startYear) * 12 + (currentMonth - startMonth);
  
    // Calculate the current quarter index (each quarter has 3 months)
    const currentQuarterIndex = Math.floor(currentMonthIndex / 3);
  
    // Calculate the current year index
    const currentYearIndex = currentYear - startYear;
  
    return { currentMonthIndex, currentQuarterIndex, currentYearIndex };
  };
  export default calculateCurrentIndexes;